import { render, staticRenderFns } from "./member-update.vue?vue&type=template&id=a64c90fa&"
import script from "./member-update.vue?vue&type=script&lang=js&"
export * from "./member-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports